import { Contact, ContactLocationItem } from "../Contact";

export const contactLocationItemDefaultValues: ContactLocationItem = {
  Type: -1,
  Gsdb: "",
};

export const contactDefaultValues: Contact = {
  Id: 0,
  FirstName: "",
  LastName: "",
  JobTitle: "",
  Email: "",
  BusinessPhone: "",
  MobilePhone: "",
  Location: contactLocationItemDefaultValues,
  RoleIds: [],
  Notes: "",
};
